<template>
  <div>
    <v-dialog
      v-model="show"
      width="423"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      scrollable
      persistent
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            text
            style="min-width: 10px !important"
            @click="closePayment()"
          >
            <v-icon color="#333333">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- {{ groups[0].admin_payment_info.profile.user }} -->

        <v-card-text v-if="loading" class="text-center">
          <div style="min-height: 35vh; padding-top: 100px">
            <v-progress-circular
              indeterminate
              color="#2d8cff"
              class="mr-2 my-2"
            />
          </div>
        </v-card-text>
        <v-card-text v-else-if="!loading">
          <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-center">
              <avatar-or-initials
                v-if="loadImageComponent"
                :name="group_detail.name"
                :image="group_detail.picture"
                size="90"
              ></avatar-or-initials>
            </v-col>
            <v-col cols="12" class="text-center mt-8">
              <!-- <div class="groupName" v-if="order_detail.group_detail.name">
                {{ order_detail.group_detail.name }}
              </div> -->
              <div class="groupName">
                {{ group_detail.name }}
              </div>
            </v-col>
            <!-- <v-col cols="12" class="paymentInfo d-flex pa-3 mt-10">
              <div>
                <div class="planTitle">Membership Price</div>
                <div class="planValue text-left">
                  ₹{{ order_detail.total_price }}
                </div>
              </div>
              <v-spacer></v-spacer>
              <div>
                <div class="planTitle text-right">Duration</div>
                <div class="planValue">
                  {{ order_detail.plan_detail.plan_name }}
                </div>
              </div>
            </v-col> -->
            <v-radio-group column v-model="subscription">
              <v-radio
                v-for="(item, id) in subscriptionPlans"
                :key="id.item"
                active-class="active-radio-div"
                class="paymentInfo"
                :value="id"
              >
                <template v-slot:label>
                  <div>
                    <span class="subsciption-price"
                      >₹{{
                        item.is_discount_price_live
                          ? item.discount_price
                          : item.price
                      }} </span
                    ><span
                      v-if="item.is_discount_price_live"
                      class="subs-dicsount"
                      style="text-decoration: line-through"
                    >
                      ₹{{ item.price }}</span
                    >
                    <span class="subs-dicsount">
                      Per
                      {{
                        item.plan.split(" ")[0].split("").slice(0, -2).join("")
                      }}
                    </span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
            <v-col cols="12" class="text-center mt-8">
              <!-- <v-btn
                class="text-none btnClass px-7"
                height="44"
                color="#2d8cff"
                @click="openPaymentGateway"
                :loading="payBtnLoader"
              >
                <span>Pay & Join</span>
              </v-btn> -->
              <v-btn
                class="text-none btnClass px-7"
                height="44"
                color="#2d8cff"
                @click="create_payment_order()"
                :loading="payBtnLoader"
              >
                <span>Pay & Join</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-else class="pt-8">
          <div>
            <v-row>
              <v-col cols="12" class="text-center">
                <img src="@/assets/paymentSuccess.png" alt="" />
              </v-col>
              <v-col cols="12" class="text-center py-5 px-8">
                <div class="heading-text">Congratulation</div>
                <div class="sub-heading-text">
                  You are now a premium member of “
                  <span
                    v-if="
                      order_detail.group_detail.name &&
                      Object.keys(order_detail).length !== 0
                    "
                  >
                    {{ order_detail.group_detail.name }}
                  </span>
                  ” group
                </div>
              </v-col>
              <v-col cols="12" class="text-center pb-10">
                <v-btn
                  class="text-none btnClass px-7"
                  height="44"
                  color="#2d8cff"
                  @click="togglePaymentDetail({ show: false })"
                >
                  <span>Go Back</span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Axios from "@/api/BaseAxios";
import apiUrl from "@/common/apiUrl";
import newAxios from "@/api/newAxios";
export default {
  name: "PaymentDetail",
  components: {
    AvatarOrInitials: () => import("@/components/AvatarOrInitials"),
  },
  data() {
    return {
      loading: true,
      loadImageComponent: false,
      payBtnLoader: false,
      paymentSuccess: false,
      formLoading: false,
      duration: null,
      order_detail: {},
      key_id: null,
      prefill: {},
      admin_id: null,
      subscriptionPlans: [],
      subscription: 0,
      name: "",
      group_detail: {},
    };
  },
  computed: {
    ...mapGetters({
      paymentShow: "payment/getShow",
    }),
    show: {
      get() {
        return this.paymentShow;
      },
      set(value) {
        return this.togglePaymentDetail({ show: value });
      },
    },
    detail() {
      return this.$store.state.payment.paymentDetail.detail;
    },
    groups() {
      if (this.userId !== null) return this.$store.state.groups.userGroups;
      return this.$store.state.groups.ownGroups;
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.openModal();
      } else {
        this.closeModal();
      }
    },
  },
  methods: {
    ...mapActions({
      togglePaymentDetail: "payment/togglePaymentDetail",
      snackBar: "snackBar/showSnack",
    }),
    openModal() {
      // this.loading = true;
      // this.create_payment_order();
      this.getGroupDetail();
      // this.loading = false;
      // this.paymentSuccess = true;
    },
    findGroupId() {
      return this.groups[0];
    },
    closePayment() {
      this.payBtnLoader = false;
      this.togglePaymentDetail({ show: false });
    },
    closeModal() {
      this.loading = true;
      this.formLoading = false;
      this.duration = null;
      this.order_detail = {};
      this.key_id = null;
      this.loadImageComponent = false;
      this.paymentSuccess = false;
    },
    getGroupDetail() {
      const onSuccess = (res) => {
        this.subscriptionPlans = res.data.group_detail.price;
        this.name = res.data.group_detail.name;
        this.group_detail = res.data.group_detail;
        this.loadImageComponent = true;
        this.loading = false;
      };
      const onFailure = () => {};
      let formData = {};
      formData["id"] = 2145;
      newAxios("get", apiUrl.GROUP_DETAIL, {
        onSuccess,
        onFailure,
        params: formData,
      });
    },
    create_payment_order() {
      // this.subscription = null;
      // this.loading = true;
      const successHandler = (res) => {
        console.log(res);
        this.duration = res.data.duration_detail;
        this.order_detail = res.data.order_detail;
        this.admin_id = this.order_detail.group_detail.admin.id;
        // console.log(this.admin_id);
        this.key_id = res.data.key_id;
        this.prefill = res.data.prefill;
        // this.loadImageComponent = true;
        this.loading = false;
        this.openPaymentGateway();
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      formData["group_id"] = this.detail.group_id;
      formData["user_id"] = parseInt(this.detail.user_id);
      formData["plan"] = this.subscriptionPlans[this.subscription].id;
      // formData["plan"] = this.detail.plan;
      // formData["plan"] = 255;
      Axios.request_POST_PARAMS(
        apiUrl.ORDER_PAYMENT,
        {},
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    openPaymentGateway() {
      const self = this;
      // this.payBtnLoader = true;
      let total_price = this.order_detail.total_price * 100;
      let options = {
        key: this.key_id, // Enter the Key ID generated from the Dashboard
        amount: total_price, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: "INR",
        name: this.order_detail.group_detail.name,
        description: "Paid Membership",
        image: this.order_detail.group_detail.picture,
        order_id: this.order_detail.order_id,
        handler: function (response) {
          self.updatePaymentDetail(true, response);
          self.paymentSuccess = true;
          this.$logEvent("premium_group");
          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_premium_group");
          }
          if (this.admin_id == 99779) {
            this.$logEvent("covesting_technologies_group");

            if (this.$vuetify.breakpoint.xsOnly) {
              this.$logEvent("mweb_covesting_technologies_group");
            }
          }

          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);
        },
        // callback_url: "http://localhost:8000/api/payment-webhook/",
        // prefill: {
        //   name: "Gaurav Kumar",
        //   email: "gaurav.kumar@example.com",
        //   contact: "9999999999",
        // },
        prefill: this.prefill,
        // notes: {
        //   address: "Razorpay Corporate Office",
        // },
        theme: {
          color: "#3399cc",
        },
      };
      var rzp1 = window.Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        this.payBtnLoader = false;
        rzp1.close();
        this.$logEvent("premium_group_failed");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_premium_group_failed");
        }
        if (this.admin_id == 99779) {
          this.$logEvent("covesting_technologies_group_failed");

          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_covesting_technologies_group_failed");
          }
        }

        // alert(response.error.code);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
        self.snackBar({
          text: `failed : ${response.error.reason}, Payment ID: ${response.error.metadata.payment_id}`,
          color: "error",
          timeout: 2500,
        });
        self.updatePaymentDetail(false, response);
        self.togglePaymentDetail({ show: false });
      });
      rzp1.open();
    },
    updatePaymentDetail(success, res) {
      const successHandler = () => {
        this.$logEvent("premium_group");
        this.$logEvent("ra_covesting_technology_payment_success");

        // if (this.$vuetify.breakpoint.xsOnly) {
        //   this.$logEvent("mweb_premium_group");
        // }
        // console.log(this.admin_id);
        // if (this.admin_id == 99779) {
        //   this.$logEvent("covesting_technologies_group");
        //   console.log("successfully enter in to covesting technologies group");
        //   if (this.$vuetify.breakpoint.xsOnly) {
        //     this.$logEvent("mweb_covesting_technologies_group");
        //   }
        // }
        this.payBtnLoader = false;

        window.location.href =
          "https://www.covesto.in/premium-groups/detail/2145";
      };
      const failureHandler = () => {
        this.payBtnLoader = false;
      };
      const finallyHandler = () => {
        if (success) {
          this.eventBus.$emit("refresh-group-detail");
        }
      };
      let formData = {};
      formData["id"] = this.order_detail.id;
      if (success) {
        formData["payment_id"] = res.razorpay_payment_id;
        formData["payment_signature"] = res.razorpay_signature;
        formData["payment_status"] = "successful";
        // const url = `${location.protocol}//${location.host}/groups/2145`;
        // window.open(url, "_self");
      } else {
        this.payBtnLoader = false;
        formData["payment_status"] = "failed";
      }
      Axios.request_PATCH(
        apiUrl.ORDER_PAYMENT,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true,
        finallyHandler
      );
    },
  },
  created: {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style scoped>
.radio-div {
  padding: 17px !important;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.subs-dicsount {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.12px;
  text-align: left;
  color: #333333ad;
}

.subsciption-price {
  font-family: Avenir;
  font-size: 25px;
  font-weight: 800;
  line-height: 34.15px;
  text-align: left;
  color: #333333;
}
.title {
  background: #2d8cff;
  color: #fff;
  font-weight: bold;
  font-size: 1.25rem;
  font-weight: bold;
  font-family: "Avenir";
}
.btnClass >>> span {
  color: #fff;
  font-weight: 700;
}
.groupName {
  color: #333333;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
}
.paymentInfo {
  background: #f7f7f7;
  border-radius: 6px;
  padding: 15px;
  width: 365px;
}
.planTitle {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  /* identical to box height */

  text-align: center;

  color: rgba(51, 51, 51, 0.7);
}
.planValue {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  text-align: center;

  color: #333333;
}
.heading-text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 33px;
  /* identical to box height */

  text-align: center;

  color: #333333;
}
.sub-heading-text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  text-align: center;

  color: #333333;
}
</style>
